<template>
    <div>
        <!-- < Top -->
        <ae-block
                :properties="['margin-bottom', 'my-0', 'scroll-x']"
                class="py-2 bg-whitesmoke home--block"
        >
            <home-top-worker
                    class="mx-1"
                    v-for="(action, index) of home.top"
                    :key="`home-actionBar-action-${index}`"
                    :action="action"
            />
            <!-- Dummy div pour avoir un padding en fin de scroll -->
            <div style="min-width: 2%!important;min-height:100%!important;visibility: hidden;"/>
        </ae-block>
        <!-- > Top -->
        <!-- < News -->
        <ae-block>
            <home-middle-news
                    v-if="home.news.length > 0"
                    :element="home.news[0]"
            />
        </ae-block>
        <!-- > News -->
        <!-- < Timeline -->
        <ae-block
                class="d-flex flex-column justify-content-around home--block bg-white"
        >
            <template v-if="actuality(1).length > 0">
                <timeline-container
                        :elements="actuality(1)"
                        :bordered="false"
                        @update="update()"
                        @refresh="update()"
                        :key="`home-mobile-timeline`"
                />
                <b-btn
                        :to="{name: 'actuality'}"
                        variant="link"
                        class="text-dark m-0 p-0"
                        block
                >
                    <i class="fas fa-chevron-down"/>
                </b-btn>
            </template>
            <home-placeholder v-else/>
        </ae-block>
        <!-- > Timeline -->
        <!-- < Meetings -->
        <ae-block
                class="bg-whitesmoke"
        >
            <h4 class="text-center text-dark font-weight-bold py-1 mb-0" style="font-size: 1.1em;">
                <i class="fas fa-map-marker-alt"></i>
                Rejoindre une activité dans mon entreprise
            </h4>
            <home-bottom-meeting
                    v-for="(meeting, index) of home.meetings.slice(0, 3)"
                    :key="`home-meeting-${index}`"
                    :meeting="meeting"
            />
            <home-placeholder
                    v-if="home.meetings.length === 0"
                    target="meetings"
            />
        </ae-block>
        <!-- > Meetings -->
    </div>
</template>

<script>
    import HomeTopWorker from "../top/Worker";
    import AeBlock from "../../Block";
    import HomeMiddleNews from "../middle/News";
    import TimelineContainer from "../../TimelineContainer";
    import HomePlaceholder from "../Placeholder";
    import HomeBottomMeeting from "../bottom/Meeting";

    export default {
        name: 'home-mobile-worker',
        components: {HomeBottomMeeting, HomePlaceholder, TimelineContainer, HomeMiddleNews, AeBlock, HomeTopWorker},
        computed: {
            home() {
                return this.$store.state.base.appInterface.home
            },
            user() {
                return this.$store.state.base.account.information
            },
            hasRoleWorker() {
                return this.$store.getters['base/account/getIsWorker'](this.user)
            },
            hasRoleCoach() {
                if (!this.user) return false
                return this.$store.getters['base/account/getIsCoach'](this.user)
            },
            hasRoleRelais() {
                return this.$store.getters['base/account/getIsWorkerRelais'](this.user)
            },
            hasRoleReferent() {
                return this.$store.getters['base/account/getIsCoachReferent'](this.user)
            },
        },
        methods: {
            async update() {
                await this.$store.dispatch('base/appInterface/home')
            },
            actuality(limit) {
                return this.home.timeline.filter((t) => {
                    return t.type === 'actuality'
                }).splice(0, limit).map((t) => {
                    return t.element
                })
            },
            reminders(limit) {
                return this.home.timeline.filter((t) => {
                    return t.type === 'coach_todo'
                }).splice(0, limit).map((t) => {
                    return t.element
                })
            }
        }
    }
</script>
